// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__23utu","approved":"Status_approved__3nFqz","rejected":"Status_rejected__1iQKe","expired":"Status_expired__AgBJt","label":"Status_label__2aJH6"};